/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod'
import { meV4Schema } from './meV4Schema'
import { userEventTypeV4NameSchema } from './userEventTypeV4NameSchema'

export const readEventResponseV4Schema = z
  .object({
    accessToken: z
      .string()
      .min(1)
      .nullable()
      .default('')
      .describe('New access token — null unless the click switched context.'),
    expiresOn: z.iso
      .datetime({ offset: true, local: true })
      .nullable()
      .default('')
      .describe('UTC expiry of the new access token — null unless the click switched context.'),
    orgChanged: z
      .boolean()
      .default(false)
      .describe('True when the active context actually changed.'),
    page: z
      .string()
      .nullish()
      .describe(
        'The UI page the client opens next (a `UIPagesV4` name, e.g. "ORGApplications"). Null when the event\r\ntype has no page, when the switch into its context was not allowed, or when that page is not among the\r\npages of the context the user ends up in (e.g. a manager for an admin-only page).'
      ),
    targetOrgId: z
      .string()
      .default('')
      .describe('Coded id of the context the event belongs to.')
      .meta({ examples: ['kJ8v2Qm7xR1a'] }),
    type: userEventTypeV4NameSchema.describe('The event type name.'),
    referenceId: z
      .string()
      .nullable()
      .default('')
      .describe('Coded id of the object the event is about, when it has one.')
      .meta({ examples: ['kJ8v2Qm7xR1a'] }),
    user: z.union([meV4Schema, z.null()]),
  })
  .describe(
    'Result of clicking an event: what the event points at, plus a new token pair when the click switched\r\ncontext. The token fields and `user` are null when no switch happened.'
  )
